import { connect } from 'react-redux'
import React, { Component } from 'react'
import { createAction } from 'redux-actions'
import { OrderedMap } from 'immutable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faSort, faTrash, faFilm, faTimes } from '@fortawesome/free-solid-svg-icons'
import { browserHistory, Link } from 'react-router'
import DropDown from '../../misc/dropdown/DropDown'
import { isMobile } from '../../misc/selectors'
import {
  DESELECT_ALL,
  deleteSelectedVideos,
} from '../../actions'
import { Modal, ModalFooter, ModalBody } from '../../misc/modals/modals'

const mapStateToProps = (state, ownProps) => {
  const { me, videos } = state
  return {
    ...ownProps,
    selected: me.selected.toArray(),
    videos,
    me,
    isMobile: isMobile(state),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  deselectAll: () => {
    dispatch(createAction(DESELECT_ALL)())
  },
  deleteSelectedVideos: () => {
    dispatch(deleteSelectedVideos())
    .then(() => dispatch(createAction(DESELECT_ALL)()))
  },
})

class VideosListHeader extends Component {
  constructor() {
    super()
    this.state = {
      deleteModalOpen: false,
      selectedVideos: new OrderedMap(),
      search: null,
    }
    this.setState = this.setState.bind(this)
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this)
    this.videosSelected = this.videosSelected.bind(this)
    this.onSearch = this.onSearch.bind(this)
  }

  toggleDeleteModal() {
    this.setState({
      deleteModalOpen: !this.state.deleteModalOpen,
    })
  }

  videosSelected(videos) {
    this.setState({ selectedVideos: videos })
  }

  onSearch(e) {
    this.setState({ search: e.target.value })
    this.props.onSearchChanged(e.target.value)
  }

  onTagChange(e) {
    if (!e.target.value.length) {
      browserHistory.push("/")
      return
    }
    browserHistory.push(`/tag/${encodeURIComponent(e.target.value)}`)
  }

  render() {
    return (
      <div className="video-list-header">
        <Modal
          isOpen={this.state.deleteModalOpen}
          toggle={this.toggleDeleteModal}
          title="Delete Confirmation"
          className="app-modal"
          darkMode={this.props.me.dark_mode}
        >
          <ModalBody>Are you sure you want to <b style={{fontWeight: 600}}>delete {this.props.selected.length} video{this.props.selected.length === 1 ? '' : 's'}</b>?</ModalBody>
          <ModalFooter>
            <button
              className="blue-button" onClick={(e) => {
                this.toggleDeleteModal()
                this.props.deleteSelectedVideos()
                this.setState({ selectedVideos: this.state.selectedVideos.clear() })
              }}
            >Delete</button>
          </ModalFooter>
        </Modal>
        {this.props.selected.length > 0
        ?
          <div className="card video-list-actions">
          <div className="selection-indicator">{this.props.selected.length} video{this.props.selected.length === 1 ? '' : 's'} <span className="desktop">selected</span></div>
          <Link
            className="video-list-action close-action leftmost"
            onClick={(e) => {
              e.preventDefault()
              this.props.deselectAll()
            }}
            to="/"
          >
            <FontAwesomeIcon icon={faTimes} /> Clear<span className="desktop"> Selection</span>
          </Link>
          <Link
            className="video-list-action"
            onClick={(e) => {
              e.preventDefault()
              this.toggleDeleteModal()
            }}
            to="/"
          >
            <FontAwesomeIcon icon={faTrash} /> Delete<span className="desktop"> Video{this.props.selected.length > 1 ? 's' : ''}</span>
          </Link>
          { this.props.isMobile ? '' :
            this.props.selected.length > 1 ?
              <Link
                className="video-list-action"
                to="/merge"
              >
                <FontAwesomeIcon icon={faFilm} /> Merge<span className="desktop">  Video{this.props.selected.length > 1 ? 's' : ''}</span>
              </Link>
            : 
              <span className="item desktop">Select another to merge...</span>
          }
        </div>
        : ''}
        {(this.props.search && this.props.search.length) || this.props.videos.total > 6 ?
          <div className="video-list-metadata">
            <button className="search-button" onClick={e => {
              this.setState({searchSelected: true})
            }}>
              <FontAwesomeIcon icon={faSearch} />Search
            </button>
            {this.state.searchSelected || (this.props.search && this.props.search.length) ?
            <input
              type="text"
              value={this.props.search || ''}
              className="filter-input"
              placeholder='Search by title ...'
              ref={el => this.searchEl = el}
              autoFocus={true}
              onChange={this.onSearch}
              onBlur={e => this.setState({searchSelected: false})}
            />
            : ''}

            <DropDown
              position="bottom right"
              className="sort-button"
              items={[
                {
                  onClick: (e) => {
                    this.props.onSortChanged('date_added', 'DESC')
                  },
                  title: 'Newest',
                  selected: this.props.videos.sort == 'date_added'
                },
                {
                  onClick: (e) => {
                    this.props.onSortChanged('plays', 'DESC')
                  },
                  title: 'Popular',
                  selected: this.props.videos.sort == 'plays'
                },
                {
                  onClick: (e) => {
                    this.props.onSortChanged('title', 'ASC')
                  },
                  title: 'A to Z',
                  selected: this.props.videos.sort == 'title'
                }
              ]}
            >
              <FontAwesomeIcon icon={faSort} /> Sort
            </DropDown>
          </div>
        : ''}
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideosListHeader)
